module.exports = __webpack_public_path__ + "img/otros.f95ffb03.png";